@if(loader){
<app-loader></app-loader>
}

<p-card [header]="isEditMode ? 'Update Salesperson' : 'Create Salesperson'">
    <form [formGroup]="salesPersonForm">
        <div class="field col-12 flex justify-content-between align-items-center">
            <div class="flex">
                <div>
                    <p-button [label]="isEditMode ? 'Update' : 'Save'" class="p-button-outlined ml-2" icon="pi pi-save"
                        size="small" (click)="saveSalesperson(salesPersonForm.value, isEditMode)"></p-button>
                </div>
                <div>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" class="p-button-outlined ml-2"
                        size="small" (click)="cancel()"></p-button>
                </div>
            </div>
            <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
        </div>
        &nbsp;
        <div class="mainframe" style=" display:flex;">
            <div class="mainView-primary" style="width:70%; margin-right:20px;">
                <div class="primary-field1" style="display:flex;">
                    <div class="field text-left" style="width:-90%">
                        <label for="website" class="label-required display">Salesperson Code</label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" pInputText placeholder="e.g SP89098" (keydown)="onKeydown($event)"
                                (blur)="checkSalesPersonCode()"
                                [readonly]="isEditMode || isManual || salesPerson.length > 0" style="width: 50%;"
                                class="p-inputtext-sm" formControlName="salespersonCode"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.salespersonCode.errors }" />
                            @if (!isEditMode) {
                            <div style="margin-left: 5px;">
                                <p-checkbox formControlName="manualEntry" *ngIf="salesPerson.length == 0"
                                    (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                    value="true"></p-checkbox>
                            </div>
                            }
                        </div>
                        <small
                            *ngIf="salesPersonForm.controls.salespersonCode.invalid && salesPersonForm.controls.salespersonCode.dirty && salesPersonForm.controls.salespersonCode.errors?.['required']"
                            class="error-message" style="color: red;">
                            Salesperson Code is required.
                        </small>
                        <small
                            *ngIf="salesPersonForm.controls.salespersonCode.invalid && salesPersonForm.controls.salespersonCode.dirty && salesPersonForm.controls.salespersonCode.errors?.['pattern']"
                            class="error-message" style="color: red;">
                            Only numeric characters are allowed.
                        </small>
                    </div>
                    <div class="flex gap-5">
                        <div class="field text-left w-full ml-4">
                            <label for="website" class="label-required display">Salesperson Name</label>
                            <input pInputText placeholder="e.g Xyz" class="w-full p-inputtext-sm"
                                (keydown)="onKeydown($event)" formControlName="salespersonName"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.salespersonName.errors }" />
                            <small *ngIf="submitted && formControls.salespersonName.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                    </div>
                </div>
                <div class="flex gap-4">
                    <div class="field text-left">
                        <label for="website">Manager Code</label>
                        <input pInputText placeholder="e.g 307" class="w-full p-inputtext-sm"
                            (keydown)="onKeydown($event)" formControlName="managerCode" />
                    </div>
                    <div class="field text-left">
                        <label for="website">Employee Code</label>
                        <input pInputText placeholder="e.g 307" class="w-full p-inputtext-sm"
                            (keydown)="onKeydown($event)" formControlName="employeeCode" />
                    </div>
                </div>
                <div class="field text-left">
                    <label for="website">Salesperson Description</label>
                    <input pInputText placeholder="e.g Xyz" class="w-full p-inputtext-sm"
                        (keydown.enter)="focusNextInput($event)" formControlName="salespersonDescription" />
                    <small *ngIf="submitted && formControls.salespersonDescription.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>
            </div>
            <div class="mainView-secondary" style=" width:30%; height: 60%; padding-top:5px; justify-content: center;">
                <div class="field text-left flex justify-content-center">
                    <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none">

                    @if (previewImage) {
                    <div style="border: 2px solid; border-radius: 10px; position: relative; object-fit: fill;">
                        <p-image [src]="previewImage" alt="Image" width="150px" height="140" [preview]="true"></p-image>
                    </div>
                    } @else {
                    <label for="fileInput" style="cursor: pointer;" (click)="fileInput.click()">
                        <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                            style="border: 2px solid; border-radius: 10px; position: static;">
                    </label>
                    }
                    @if (previewImage) {
                    <div class="flex justify-content mt-2" style="align-items:center ;">
                        <p-button class="p-button-outlined ml-2 " severity="danger" icon="pi pi-trash" size="small"
                            (click)="deleteImage()"></p-button>
                    </div>
                    }
                    <!-- <div class="field text-left pt34">
                    <label for="website">Manager Code</label>
                    <input pInputText placeholder="e.g 307" class="w-full p-inputtext-sm" />
                </div> -->
                </div>
                <!-- <div class="field text-left flex align-items-center">
                    <p-checkbox label="Active" formControlName="isActive" [binary]="true"></p-checkbox>
                </div> -->

            </div>
        </div>
        <p-tabView>
            <p-tabPanel header="General Information">
                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address" class="label-required display">Address</label>
                            <input pInputText placeholder="Street Address1" class="w-full p-inputtext-sm"
                                (keydown)="onKeydown($event)" formControlName="addressLine1" [ngClass]="{'ng-invalid ng-dirty': submitted &&
                            formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                                (keydown)="onKeydown($event)" formControlName="addressLine2" />
                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full p-inputtext-sm"
                                        (keydown)="onKeydown($event)" formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>
 <div class=" ml-1">


      <!-- state code changed-->
                                    <!-- <input pInputText placeholder="State" class="w-full p-inputtext-sm" formControlName="state" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }" /> -->
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" formControlName="state"
                                        [suggestions]="filterStates" (onSelect)="setState($event)"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                        (keydown.enter)="focusNextInput($event)">
                                        <ng-template let-state pTemplate="item">
                                            {{ state.stateCode  }} - {{ state.stateName }}
                                        </ng-template>
                                    </p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>



                                <div class="ml-1">
                                    <input pInputText placeholder="Zip" class="w-full p-inputtext-sm"
                                        (keydown)="onKeydown($event)" formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors?.['required']"
                                        id="zip-required-error" class="text-red-500">Zip code is required.</small>
                                    <small
                                        *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                        id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                        digits.</small>
                                </div>
                            </div>
                            <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1"
                                formControlName="country" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field text-left">
                            <label for="address">Email Address</label>
                            <input pInputText placeholder="e.g. email@yourcomapny.com" class="w-full p-inputtext-sm"
                                formControlName="email" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }" />
                            <small *ngIf="submitted && formControls.email.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left">
                            <label for="phone">Phone</label>
                            <input pInputText placeholder="Phone" class="w-full p-inputtext-sm" formControlName="phone"
                                (keydown)="onKeydown($event)" />
                            <small *ngIf="submitted && formControls.phone.errors" class="text-red-500">Invalid phone
                                number.</small>
                        </div>

                        <div class="field text-left ">
                            <label for="Mobile">Mobile</label>
                            <input pInputText placeholder="Mobile" class="w-full p-inputtext-sm"
                                formControlName="mobile" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }" />
                            <small *ngIf="submitted && formControls.mobile.errors" id="name-error"
                                class="text-red-500">Invalid mobile number.</small>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
            <!-- created by Prajakta on date 07/06/2024. created for contact Screen display for the salesperson -->
            <p-tabPanel header="Contacts & Addresses" *ngIf="isEditMode">
                <app-contact-list *ngIf="salespersonId && salespersonId > 0"
                    [salespersonId]="salespersonId"></app-contact-list>
            </p-tabPanel>
        </p-tabView>
    </form>
</p-card>
<p-toast></p-toast>